module.exports = __webpack_public_path__ + "img/product.3a67c210.png";